import { HandHelping, MessageSquareMore, Phone } from 'lucide-react';

export const contactUsItems = [
  {
    title: 'Request a release',
    description:
      'Send a release request email by clicking the button below. Our emergency channel is monitored 24 hours a day, 7 days a week, 365 days a year.',
    icon: HandHelping,
    href: 'mailto:release@codekeeper.co',
    linkText: 'Submit request',
  },
  {
    title: 'Talk to Sales',
    description:
      'Interested in learning about our other solutions? Use our website chat to speak with a sales representative.',
    icon: Phone,
    href: 'https://codekeeper.co/contact-sales',
    linkText: 'Contact sales',
  },
  {
    title: 'Any questions?',
    description: 'Have a question? Click the button below to visit our support page.',
    icon: MessageSquareMore,
    href: 'https://codekeeper.co/contact-support',
    linkText: 'Chat with us',
  },
];
